





























import Vue from 'vue'
import VueI18n from 'vue-i18n'
import mixins from 'vue-typed-mixins'
import { generalDialogMixin } from '@/mixins'
import { SystemNetwork } from '@/types/api'
import easyapi from '@/easyapi'

type network_mode_t = 'static' | 'dynamic'
export default mixins(generalDialogMixin).extend({
  data (): {
    mode: network_mode_t,
    MODES: Array<{key: network_mode_t, label: VueI18n.TranslateResult}>,
    d: SystemNetwork
  } {
    return {
      mode: 'static',
      MODES: [
        { key: 'static', label: this.$t('sys.network.static') },
        { key: 'dynamic', label: this.$t('sys.network.dhcpClient') },
      ],
      d: {
        dhcpClient: false,
        ip: '',
        ipv6: '',
        mac: '',
        netmask: '',
        gateway: '',
        dns: '',
      }
    }
  },
  computed: {
    invalid (): boolean {
      if (this.mode === 'static') {
        return this.$validator.errors.any() || !this.d.ip || !this.d.netmask
      } else {
        return false
      }
    }
  },
  mounted () {
    this.d = Object.assign({}, this.$s.$state.sys.network.setting)
    if (this.d.dhcpClient) {
      this.mode = 'dynamic'
    }
  },
  methods: {
    apply () {
      if (!this.invalid) {
        const paramsToSend = {
          ...this.d,
          dhcpClient: this.mode === 'dynamic'
        }
        easyapi.setNetworkConfig(paramsToSend)
      }
    }
  }
})
